<!-- RoundIcon.svelte -->
<script>
  export let label = "";
  export let bgColor = "bg-blue-500";
  export let textColor = "text-white";
  export let size = "h-8 w-8"; // You can adjust the default size
  export let padding = ""; // Add padding classes here (e.g., "p-2")
  export let margin = ""; // Add margin classes here (e.g., "m-2")
</script>

<div class="{bgColor} {size} rounded-full flex items-center justify-center {textColor} {padding} {margin}">
  {#if label.length > 0}
    {label.substring(0, 1)}
  {/if}
</div>

<style>
  /* You can add additional styles here if needed */
</style>
